import { FC } from 'react';
import { CuadroCard } from 'components/Card/CuadroCard';
import { Button } from 'components/Button';
import { ISeriesData } from 'store/series/types';
import { ICuadrosData } from 'store/cuadros/types';
import {
  SerieTitleWrapper,
  SerieTitle,
  SerieTitleAccent,
  SerieGrid,
  ViewAllWrapper,
} from './styled';

const PREVIEW_LIMIT = 6;

interface Props {
  serie: ISeriesData;
  cuadros: ICuadrosData[];
}

export const Serie: FC<Props> = ({ serie, cuadros }) => {
  const serieCuadros = cuadros
    .filter(c => c.id_serie === serie.id)
    .sort((a, b) => a.order - b.order);

  const previewCuadros = serieCuadros.slice(0, PREVIEW_LIMIT);
  const hasMore = serieCuadros.length > PREVIEW_LIMIT;

  return (
    <>
      <SerieTitleWrapper>
        <SerieTitle>{serie.title}</SerieTitle>
        <SerieTitleAccent />
      </SerieTitleWrapper>
      <SerieGrid>
        {previewCuadros.map(cuadro => (
          <CuadroCard key={cuadro.id} cuadro={cuadro} />
        ))}
      </SerieGrid>
      {hasMore && (
        <ViewAllWrapper>
          <Button to={`/serie/${serie.id}`} style={{ maxWidth: 260 }}>
            Ver colección completa
          </Button>
        </ViewAllWrapper>
      )}
    </>
  );
};
